// China
// export const locale = {
//   lang: 'ch',
//   data: {
//     TRANSLATOR: {
//       SELECT: '选择你的语言',
//     },
//     MENU: {
//       NEW: '新',
//       ACTIONS: '行动',
//       CREATE_POST: '创建新帖子',
//       PAGES: 'Pages',
//       FEATURES: '特征',
//       APPS: '应用',
//       DASHBOARD: '仪表板',
//     },
//     AUTH: {
//       GENERAL: {
//         OR: '要么',
//         SUBMIT_BUTTON: '提交',
//         NO_ACCOUNT: '没有账号？',
//         SIGNUP_BUTTON: '注册',
//         FORGOT_BUTTON: '忘记密码',
//         BACK_BUTTON: '背部',
//         PRIVACY: '隐私',
//         LEGAL: '法律',
//         CONTACT: '联系',
//       },
//       LOGIN: {
//         TITLE: '创建帐号',
//         BUTTON: '签到',
//       },
//       FORGOT: {
//         TITLE: 'Forgotten Password?',
//         DESC: 'Enter your email to reset your password',
//         SUCCESS: 'Your account has been successfully reset.',
//       },
//       REGISTER: {
//         TITLE: 'Sign Up',
//         DESC: 'Enter your details to create your account',
//         SUCCESS: 'Your account has been successfuly registered.',
//       },
//       INPUT: {
//         EMAIL: 'Email',
//         FULLNAME: 'Fullname',
//         PASSWORD: 'Password',
//         CONFIRM_PASSWORD: 'Confirm Password',
//         USERNAME: '用戶名',
//       },
//       VALIDATION: {
//         INVALID: '{{name}} is not valid',
//         REQUIRED: '{{name}} is required',
//         MIN_LENGTH: '{{name}} minimum length is {{min}}',
//         AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
//         NOT_FOUND: 'The requested {{name}} is not found',
//         INVALID_LOGIN: 'The login detail is incorrect',
//         REQUIRED_FIELD: 'Required field',
//         MIN_LENGTH_FIELD: 'Minimum field length:',
//         MAX_LENGTH_FIELD: 'Maximum field length:',
//         INVALID_FIELD: 'Field is not valid',
//       },
//     },
//     ECOMMERCE: {
//       COMMON: {
//         SELECTED_RECORDS_COUNT: 'Selected records count: ',
//         ALL: 'All',
//         SUSPENDED: 'Suspended',
//         ACTIVE: 'Active',
//         FILTER: 'Filter',
//         BY_STATUS: 'by Status',
//         BY_TYPE: 'by Type',
//         BUSINESS: 'Business',
//         INDIVIDUAL: 'Individual',
//         SEARCH: 'Search',
//         IN_ALL_FIELDS: 'in all fields',
//       },
//       ECOMMERCE: 'eCommerce',
//       CUSTOMERS: {
//         CUSTOMERS: '顾客',
//         CUSTOMERS_LIST: '客户名单',
//         NEW_CUSTOMER: 'New Customer',
//         DELETE_CUSTOMER_SIMPLE: {
//           TITLE: 'Customer Delete',
//           DESCRIPTION: 'Are you sure to permanently delete this customer?',
//           WAIT_DESCRIPTION: 'Customer is deleting...',
//           MESSAGE: 'Customer has been deleted',
//         },
//         DELETE_CUSTOMER_MULTY: {
//           TITLE: 'Customers Delete',
//           DESCRIPTION: 'Are you sure to permanently delete selected customers?',
//           WAIT_DESCRIPTION: 'Customers are deleting...',
//           MESSAGE: 'Selected customers have been deleted',
//         },
//         UPDATE_STATUS: {
//           TITLE: 'Status has been updated for selected customers',
//           MESSAGE: 'Selected customers status have successfully been updated',
//         },
//         EDIT: {
//           UPDATE_MESSAGE: 'Customer has been updated',
//           ADD_MESSAGE: 'Customer has been created',
//         },
//       },
//     },
//   },
// };

// China
export const locale = {
  lang: 'ch',
  data: {
    TRANSLATOR: {
      SELECT: '选择你的语言',
      CLOSE: '关闭',
    },
    SEO: {
      SITE_NAME: 'BimParts - 工业零部件和设备',
      HOMEPAGE_TITLE: 'BimParts - 越南领先的工业零部件和设备供应商',
      HOMEPAGE_DESCRIPTION:
        'BIM BIM股份公司 - 越南首屈一指的工业零部件、叉车零部件和重型设备组件供应商。质量保证，价格具有竞争力。',
      HOMEPAGE_KEYWORDS: '工业零部件, 叉车零部件, 设备零件, 越南供应商, BimParts, 重型设备',
      PRODUCT_TITLE_TEMPLATE: '{productName} | BimParts 工业零部件',
      PRODUCT_DESCRIPTION_TEMPLATE:
        '来自{brandName}的{productName} - 高质量工业零部件，价格具有竞争力。越南BimParts有售。',
      CATEGORY_TITLE_TEMPLATE: '{categoryName} | 工业零部件 | BimParts',
      CATEGORY_DESCRIPTION_TEMPLATE:
        '浏览{categoryName}工业零部件和设备。越南BimParts提供有保修的优质产品。',
      ABOUT_TITLE: '关于BimParts - 工业零部件专家',
      ABOUT_DESCRIPTION: '了解BIM BIM股份公司，越南自成立以来值得信赖的工业零部件和设备供应商。',
      CONTACT_TITLE: '联系BimParts - 工业零部件供应商',
      CONTACT_DESCRIPTION: '联系BimParts咨询工业零部件。在越南提供专业支持和全国配送。',
    },
    MENU: {
      HOME: '首页',
      CATEGORIES: '分类',
      NEW: '新建',
      DOWNLOAD: '下载',
      CERTIFICATE: '证书',
      ACTIONS: '操作',
      CREATE_POST: '创建新帖子',
      ALL_CATEGORIES: '全部分类',
      VIDEO_CHANNEL: '视频频道',
      ABOUT_US: '关于',
      CONTACT: '联系我们',
      TOP_RANKING_PRODUCTS: '热门排行榜商品',
      PAGES: '页面',
      FEATURES: '功能',
      APPS: '应用',
      DASHBOARD: '仪表板',
      DELIVER_TO: '送至',
      LOCATION: {
        DELIVER_TO: '送至',
        SPECIFY_LOCATION: '请指定您的收货地址',
        SHIPPING_NOTICE: '运送选项和费用会根据您的位置而有所不同',
        ADD_ADDRESS: '添加地址',
        OR: '或',
        SELECT_COUNTRY: '选择国家',
        SAVE: '保存',
      },
      LANGUAGE: {
        SET_LANGUAGE_CURRENCY: '设置语言和货币',
        DESCRIPTION: '请选择您偏好的语言和货币。',
        DESCRIPTION2: '您可以随时更新设置。',
        LANGUAGE: '语言',
        CURRENCY: '货币',
        SAVE: '保存',
      },
      PROFILE: {
        EDIT_INFO: '编辑资料',
        ADMIN_PAGE: '管理员页面',
        MY_CART: '我的购物车',
        MY_ORDERS: '我的订单',
        MY_INQUIRIES: '我的咨询',
        MY_EQUIPMENT: '我的设备',
        MY_EQUIPMENT_STATISTICS: '我的设备统计',
        MY_TOP_PRODUCTS: '购买最多的产品',
        LOGOUT: '登出',
      },
    },
    CONTACT_PAGE: {
      TITLE: '联系我们',
      INTRO: '我们的专业团队随时为您提供支持。请选择相应部门直接联系，或通过下方表单发送咨询请求。',
      TAB_ALL: '全部',
      SEARCH_PLACEHOLDER: '按姓名、职位、负责区域、电话号码搜索...',
      RESULT_COUNT: '{{count}} 位联系人',
      LOADING: '正在加载联系人列表...',
      EMPTY: '未找到符合条件的联系人。',
      PERSON_LANGUAGES: '语言：{{languages}}',
      BTN_COLLAPSE: '收起',
      BTN_VIEW_DETAIL: '查看详情',
      BTN_CONTACT_PERSON: '联系该联系人',
      DETAIL_BIO_LABEL: '简介：',
      DETAIL_DEPARTMENT_LABEL: '部门：',
      FORM_TITLE: '发送咨询请求',
      FORM_DESC: '请填写下方信息，我们将尽快与您联系。',
      FORM_SUCCESS: '您的留言已成功发送！我们将尽快与您联系。',
      FORM_SUBMITTING: '正在发送...',
      FORM_SUBMIT: '发送留言',
      LABEL_FULL_NAME: '姓名',
      LABEL_EMAIL: '电子邮箱',
      LABEL_PHONE: '电话号码',
      LABEL_COMPANY: '公司',
      LABEL_DEPARTMENT: '接收部门',
      LABEL_PERSON: '接收人',
      LABEL_SUBJECT: '主题',
      LABEL_MESSAGE: '内容',
      PLACEHOLDER_SELECT_DEPARTMENT: '-- 选择部门 --',
      PLACEHOLDER_SELECT_PERSON: '-- 选择联系人 --',
      LOADING_PERSONS: '正在加载联系人列表...',
      ERR_FULL_NAME: '请输入您的姓名。',
      ERR_EMAIL: '电子邮箱无效。',
      ERR_SUBJECT: '请输入主题。',
      ERR_MESSAGE: '请输入留言内容。',
      ERR_PHONE_REQUIRED: '请输入您的电话号码。',
      ERR_PHONE_PATTERN: '电话号码只能包含数字（0-9）。',
      ERR_PHONE_MAXLENGTH: '电话号码不能超过15位数字。',
      ERR_PHONE_INVALID: '电话号码无效。',
      ERR_SUBMIT: '发送留言失败，请重试。',
      ERR_SUBMIT_GENERIC: '发送留言时出错，请稍后重试。'
    },
    MY_INQUIRIES: {
      TITLE: '我的咨询',
      SEARCH_PLACEHOLDER: '按主题、内容、部门、联系人搜索...',
      LOADING: '正在加载咨询列表...',
      LOADING_DETAIL: '正在加载详情...',
      EMPTY: '您还没有提交任何咨询。',
      COL_SUBJECT: '主题',
      COL_DEPARTMENT: '部门',
      COL_STATUS: '状态',
      COL_CREATED: '提交时间',
      STATUS_ALL: '全部状态',
      STATUS_NEW: '新',
      STATUS_IN_PROGRESS: '处理中',
      STATUS_RESOLVED: '已解决',
      STATUS_CLOSED: '已关闭',
      DETAIL_SUBJECT: '主题',
      DETAIL_DEPARTMENT: '接收部门',
      DETAIL_PERSON: '接收联系人',
      DETAIL_CREATED: '提交时间',
      DETAIL_RESOLVED_AT: '处理时间',
      DETAIL_RESOLVED_BY: '处理人',
      DETAIL_MESSAGE: '您的留言',
      DETAIL_ADMIN_NOTES: 'Sapatco 回复',
      PAGE_INFO: '显示 {{from}}–{{to}}，共 {{total}} 条',
      ERR_DETAIL: '无法加载咨询详情，请重试。'
    },
    EQUIPMENT: {
      PAGE_TITLE: '我的设备',
      ADD_EQUIPMENT: '添加设备',
      IMPORT_EXPORT: '导入/导出',
      EMPTY_TITLE: '添加您的第一个设备',
      EMPTY_DESC: '添加设备以开始浏览特定于机器的信息，并跟踪相关的订单和研究。',
      INFO_ORDER_TITLE: '开始从您存储的机器中订购零件，以接收零件建议。',
      INFO_ORDER_DESC: '通过“我的设备”订购零件，我们可以开始为您的车队建立洞察并加快您的订购流程。',
      CONFIGURE_MACHINE: '配置您的机器',
      OWN_REFERENCE: '自有参考',
      LOCATION: '位置',
      PRODUCTION_MONTH: '生产月份',
      PRODUCTION_YEAR: '生产年份',
      SELECT_MACHINE: '选择机器',
      FILTER_MAKES_MODELS: '筛选所有品牌和型号',
      MAKE: '品牌',
      MODEL: '型号',
      TYPE_OR_SELECT: '输入或选择',
      SELECT_MAKE_FIRST: '请先选择品牌',
      SERIAL_PREFIX: '序列号前缀',
      SERIAL_NUMBER: '序列号',
      FIELD_REQUIRED: '此字段为必填项',
      REFINE_MODEL: '细化型号',
      SELECT_MODEL_MACHINE: '选择您机器的型号',
      REFINE_SPECS: '细化规格（可选）',
      SELECT_SPECS_MACHINE: '选择您机器的规格。',
      MAST: '提升架',
      CANCEL: '取消',
      PRODUCTION: '生产',
      ADDED: '已添加',
      VIEW_DETAIL: '查看详情',
      RECENT_SEARCHES: '最近搜索的品牌/型号',
      PURCHASE_HISTORY: '购买历史',
      PART_PACKAGES: '零件包',
      NO_PURCHASE_HISTORY: '此设备没有购买历史。',
      NO_PACKAGES: '此设备没有可用的零件包。',
      REORDER: '重新订购',
      ADD_PACKAGE_TO_CART: '将包裹添加到购物车',
      LICENSE_PLATE: '车牌号',
      HOUR_METER: '运行时间 (小时)',
      NOTES: '备注',
      EDIT_EQUIPMENT: '编辑设备',
      UPDATE_EQUIPMENT: '更新设备',
      HOURS: '小时',
      ADD_PHOTO: '添加设备照片',
      CHANGE_PHOTO: '更换照片',
      COMPATIBLE_PARTS: '适配配件',
	  NO_COMPATIBLE_PARTS: '未找到适用于此设备的兼容零件。',
      TIRE_INFO: '轮胎信息',
      STEERING_TIRE_SIZE: '转向轮胎规格',
      STEERING_TIRE_TYPE: '转向轮胎类型',
      STEERING_TIRE_LABEL: '转向轮胎',
      LOAD_TIRE_SIZE: '承载轮胎规格',
      LOAD_TIRE_TYPE: '承载轮胎类型',
      LOAD_TIRE_LABEL: '承载轮胎',
      SPARE_TIRE_SIZE: '备用轮胎规格',
      SPARE_TIRE_TYPE: '备用轮胎类型',
      SPARE_TIRE_LABEL: '备用轮胎'
    },
    DOWNLOAD: {
      PAGE_TITLE: '下载文件、目录和宣传册',
      LOADING: '正在加载数据...',
      ERROR_TITLE: '发生错误',
      ERROR_RETRY: '重试',
      FILE: '文件',
      EMPTY_CATEGORY: '该分类下没有文件。',
      EMPTY_TITLE: '没有分类',
      EMPTY_DESC: '当前没有可供下载的文件分类。',
      NO_PREVIEW: '无法预览此文件',
      NO_PREVIEW_HINT: '请下载查看内容',
      NO_PREVIEW_FORMAT: '文件格式 {{ext}} 无法在浏览器中预览。',
      NO_PREVIEW_ACTION: '请下载该文件并使用合适的应用程序打开。',
      // DOWNLOAD_NOW: '立即下载',
      DOWNLOAD_BTN: '下载',
      LOADING_PREVIEW: '正在加载预览...',
      PAID_OVERLAY: '付费文件',
      PAID_BADGE: '有费',
  FREE_BADGE: '免费',
      PAID_BLOCK_TITLE: '付费文件',
      PAID_BLOCK_DESC: '请联系我们以请求访问此文件。',
      PAID_BUTTON_LABEL: '付费文件',
      PREVIEW_10_PAGES: '预览 – 前10页',
      PAID_PAYMENT_DESC: '付款即可下载完整文件。',
      UNLOCKED_TITLE: '文件已解锁',
      UNLOCKED_DESC: '您可以下载完整文件。',
      PAY_WITH_MOMO: '通过Momo支付',
      PROCESSING_PAYMENT: '处理中...',
      PENDING_PAYMENT: '请使用Momo应用扫描二维码完成支付。',
      CONFIRM_PAID_DOWNLOAD: '我已付款 – 立即下载',
      CONFIRMING_PAYMENT: '确认中...',
      RETRY_PAYMENT: '重新支付',
      IPN_PROCESSING: '正在确认付款，请稍候...',
      IPN_SUCCESS: '付款成功！您的文件正在下载。',
      IPN_REDOWNLOAD: '重新下载',
      SEARCH_PLACEHOLDER: '搜索文档...',
      ALL_CATEGORIES: '所有类别',
      SEARCH_RESULTS: '搜索结果 ({{total}})',
      SEARCHING: '正在搜索...',
      NO_SEARCH_RESULTS: '未找到匹配的文档。'
    },
    ABOUT_US: {
      PAGE_TITLE: '关于我们',
      ADDRESS_LABEL: '地址',
      COMPANY_NAME: 'BIM BIM股份有限公司',
      COMPANY_SHORT_NAME: 'BIM BIM JSC',
      COMPANY_TAX_CODE: '0318955259',
      COMPANY_ADDRESS: '119号B路，协平政查区，守德市，胡志明市，越南',
      COMPANY_HOTLINE: '+84 934 920 935',
      COMPANY_EMAIL: 'marketing@bimbimgroup.com',
      VISION: '愿景',
      VISION_CONTENT: '成为工业零部件和设备供应行业值得信赖的领先合作伙伴。',
      MISSION: '使命',
      MISSION_CONTENT: '以具有竞争力的价格提供高质量产品，提供专业快捷的服务。',
      WHY_CHOOSE_US: '为什么选择我们',
      CONTACT_TITLE: '联系我们',
      CONTACT_DESC: '获取咨询和最优报价',
      FEATURES: {
        QUALITY: {
          TITLE: '质量保证',
          DESC: '正品产品，提供全面保修',
        },
        SHIPPING: {
          TITLE: '全国配送',
          DESC: '快速安全的运输',
        },
        SUPPORT: {
          TITLE: '24/7支持',
          DESC: '专业咨询团队',
        },
        CERTIFICATE: {
          TITLE: '证照齐全',
          DESC: '信誉良好、透明经营',
        },
      },
    },
    AUTH: {
      GENERAL: {
        OR: '或',
        SUBMIT_BUTTON: '提交',
        NO_ACCOUNT: '还没有账户？',
        SIGNUP_BUTTON: '注册',
        FORGOT_BUTTON: '忘记密码',
        BACK_BUTTON: '返回',
        PRIVACY: '隐私',
        LEGAL: '法律条款',
        CONTACT: '联系我们',
      },
      LOGIN: {
        TITLE: '登录账户',
        BUTTON: '登录',
      },
      FORGOT: {
        TITLE: '忘记密码？',
        DESC: '请输入您的邮箱以重置密码',
        SUCCESS: '您的账户已成功重置。',
      },
      REGISTER: {
        TITLE: '注册账户',
        DESC: '请输入详细信息以创建账户',
        SUCCESS: '您的账户已成功注册。',
      },
      INPUT: {
        EMAIL: '电子邮箱',
        FULLNAME: '姓名',
        PASSWORD: '密码',
        CONFIRM_PASSWORD: '确认密码',
        USERNAME: '用户名',
      },
      VALIDATION: {
        INVALID: '{{name}} 无效',
        REQUIRED: '必须填写 {{name}}',
        MIN_LENGTH: '{{name}} 的最小长度为 {{min}}',
        AGREEMENT_REQUIRED: '必须同意条款和条件',
        NOT_FOUND: '未找到所请求的 {{name}}',
        INVALID_LOGIN: '登录信息不正确',
        REQUIRED_FIELD: '必填项',
        MIN_LENGTH_FIELD: '最小长度：',
        MAX_LENGTH_FIELD: '最大长度：',
        INVALID_FIELD: '字段无效',
      },
    },
    ECOMMERCE: {
      COMMON: {
        BANNER_SLOGAN: 'Bimparts.vn 拒绝假货，杜绝劣质，只做正品',
        SELECTED_RECORDS_COUNT: '已选择记录数量：',
        ALL: '全部',
        SUSPENDED: '已停用',
        ACTIVE: '启用中',
        FILTER: '筛选',
        BY_STATUS: '按状态',
        BY_TYPE: '按类型',
        BUSINESS: '企业',
        INDIVIDUAL: '个人',
        SEARCH: '搜索',
        IN_ALL_FIELDS: '在所有字段中',
    SEARCH_BY_SKU: '搜索品名、零件号、SKU...',
        SEARCH_FOR_DOCUMENTS: '搜索文档',
        RESET: '重置',
        SEARCH_BRAND: '搜索品牌',
        SEARCH_MANUFACTURER: '搜索生产厂',
        FOUND_RESULTS: '找到 {{total}} 个产品',
      },
      PRODUCT: {
      SAVE: '节省',
      SELECT_TYPE: '选择类别',
      QUANTITY: '数量',
      ADD_TO_CART_SUCCESS: '已成功加入购物车',
      PRODUCT_ADDED: '产品添加成功',
        CATEGORIES: '产品分类',
        BEST_SELLING: '畅销商品',
        SPECIAL_DISCOUNTS: '特别优惠',
        NEW_ARRIVALS: '新品上市',
        VIEW_MORE: '查看更多',
        PRODUCT: '产品',
        PRODUCTS: '产品',
        NO_PRODUCTS: '未找到产品',
        ADD_TO_CART: '加入购物车',
        REMAINING: '剩余',
        SKU_LABEL: 'SKU',
        ORDER_NOW: '立即下单',
        REQUEST_QUOTE: '请求报价',
        VIEW_PRICE: '查看价格',
        CONTACT: '联系',
        AVAILABLE: '有货',
        OUT_OF_STOCK: '缺货',
        NOT_UPDATED: '未更新',
        REQUIRED_LOGIN: '登录',
        BRAND_USED: '适用品牌：',
        MANUFACTURER: '生产厂家: ',
        BRAND: '品牌',
        SOLD: '已售：',
        VIEW_DETAIL: '查看详情',
        ZOOM_HINT: '将鼠标移到图片上放大',
        FROM_BRAND: '来自品牌：',
        QUANTITY_LABEL: '数量：',
        REMAINING_WITH_COUNT: '剩余 {{count}} 件产品',
        PART_CODE: '零件代码',
        SHIP: '运费',
        WARRANTY: '保修',
        WEIGHT: '重量',
        DIMENSIONS: '尺寸 (长x宽x高)',
      },
      PRODUCT_INFORMATION: {
        TAB_DETAILS: '概述',
        TAB_DESCRIPTION: '详细描述',
        TAB_POLICY: '销售政策',
        EMPTY_SUMMARY: '暂无产品详细信息。',
        EMPTY_DESCRIPTION: '暂无详细描述。',
        POLICY_VAT_EXCLUDED: '以上价格不含增值税 {{value}}%',
        POLICY_WARRANTY_PREFIX: '产品按照',
        POLICY_MANUFACTURER: '制造商',
        POLICY_WARRANTY_SUFFIX: '的保修政策在全球范围内提供技术保修',
        POLICY_HOTLINE_PREFIX: '如需了解更多详情请拨打',
        TAB_SUPPLIER_QUOTES: '供应商报价',
      },
      SUPPLIER_QUOTES: {
        TITLE: '供应商报价',
        TAB_TITLE: '供应商报价',
        ADD_NEW: '添加新报价',
        ADD_NOW: '立即添加报价',
        CREATE_TITLE: '添加新供应商报价',
        EDIT_TITLE: '更新供应商报价',
        PRODUCT_LABEL: '产品',
        SUPPLIER_NAME: '供应商名称',
        SUPPLIER_NAME_PLACEHOLDER: '输入供应商名称（最多200个字符）',
        SUPPLIER_NAME_REQUIRED: '请输入供应商名称',
        SUPPLIER_NAME_MAXLENGTH: '供应商名称不能超过200个字符',
        VARIANT: '变体 / 分类',
        VARIANT_FALLBACK: '分类 {{index}}',
        ALL_VARIANTS: '所有分类',
        VARIANT_COMMON: '适用于所有分类',
        NO_VARIANT_COMMON: '无分类（通用报价）',
        VARIANT_BADGE_COMMON: '通用',
        VARIANT_HINT: '如果此报价仅适用于特定变体，请选择具体分类。',
        NO_VARIANT_HINT: '该产品无分类变体，报价将适用于整个产品。',
        LOADING_VARIANTS: '正在加载分类...',
        PRICE: '供应价格',
        PRICE_WITH_UNIT: '供应价格 (VND)',
        PRICE_REQUIRED: '请输入供应价格',
        PRICE_MIN: '供应价格必须大于或等于0',
        QUANTITY: '供应数量',
        QUANTITY_PLACEHOLDER: '例如：10',
        QUANTITY_REQUIRED: '请输入供应数量',
        QUANTITY_MIN: '数量必须大于或等于0',
        QUANTITY_HINT: '支持整数或小数（米、公斤等）',
        QUOTE_TIME: '报价时间',
        QUOTE_TIME_REQUIRED: '请选择报价时间',
        NOTE: '备注',
        NOTE_PLACEHOLDER: '输入关于运输、增值税、有效期、联系方式等的备注...（最多200个字符）',
        NOTE_MAXLENGTH: '备注不得超过200个字符',
        ACTIONS: '操作',
        ACTION_EDIT: '编辑',
        ACTION_DELETE: '删除',
        EDIT_TOOLTIP: '编辑报价',
        DELETE_TOOLTIP: '删除报价',
        CANCEL: '取消',
        SAVE_CHANGES: '保存更改',
        CREATE_BTN: '创建报价',
        REFRESH_TOOLTIP: '刷新列表',
        FOUND_COUNT: '找到 {{count}} 条报价',
        SEARCH_SUPPLIER_PLACEHOLDER: '按供应商名称搜索...',
        FROM_DATE: '起始日期',
        FILTER_DATE_TOOLTIP: '过滤此日期及以后的报价',
        CLEAR_DATE: '清除日期',
        SEARCH: '搜索',
        RESET_FILTERS: '重置',
        RESET_TOOLTIP: '刷新并重置筛选',
        LOADING: '正在加载供应商报价...',
        EMPTY_TITLE: '暂无供应商报价',
        EMPTY_DESC_ALL: '点击下方按钮为此产品添加第一条供应商报价。',
        EMPTY_DESC_FILTER: '所选变体暂无报价。',
        DELETE_CONFIRM_TITLE: '确认删除报价',
        DELETE_CONFIRM_DESC: '您确定要删除供应商 "{{supplier}}" 的报价吗？',
        DELETE_WAIT: '正在删除报价...',
        DELETE_SUCCESS: '删除供应商报价成功',
        DELETE_ERROR: '删除供应商报价失败',
        CREATE_SUCCESS: '添加供应商报价成功',
        CREATE_ERROR: '添加供应商报价失败',
        UPDATE_SUCCESS: '更新供应商报价成功',
        UPDATE_ERROR: '更新供应商报价失败',
      },

      ECOMMERCE: '电子商务',
      CUSTOMERS: {
        CUSTOMERS: '客户',
        CUSTOMERS_LIST: '客户列表',
        NEW_CUSTOMER: '新客户',
        DELETE_CUSTOMER_SIMPLE: {
          TITLE: '删除客户',
          DESCRIPTION: '确定要永久删除该客户吗？',
          WAIT_DESCRIPTION: '正在删除客户...',
          MESSAGE: '客户已被删除',
        },
        DELETE_CUSTOMER_MULTY: {
          TITLE: '删除多个客户',
          DESCRIPTION: '确定要永久删除选定的客户吗？',
          WAIT_DESCRIPTION: '正在删除选定客户...',
          MESSAGE: '选定客户已被删除',
        },
        UPDATE_STATUS: {
          TITLE: '选定客户的状态已更新',
          MESSAGE: '客户状态更新成功',
        },
        EDIT: {
          UPDATE_MESSAGE: '客户信息已更新',
          ADD_MESSAGE: '客户已创建',
        },
      },
    },
    PROFILE: {
      MY_INQUIRIES: '我的咨询',
      CHANGE_AVATAR: {
        TITLE: '更换头像',
        CURRENT: '当前头像',
        CHOOSE_NEW: '选择新图片：',
        PREVIEW: '预览：',
        CANCEL: '取消',
        SAVE: '保存',
        TOOLTIP: '选择个人资料图片',
      },
      USER_INFO: {
        TITLE: '账户信息',
        DETAIL: {
          USER_NAME: '姓名',
          PHONE: '电话号码',
          EMAIL: '电子邮件',
          ROLE: '角色',
          CUSTOMER_CODE: '客户代码',
          LOADING_ROLE: '正在加载...',
          NO_ROLE: '未分配角色',
          NO_CUSTOMER_CODE: '无',
          GENDER: {
            LABEL: '性别',
            OPTIONS: {
              MALE: '男',
              FEMALE: '女',
              OTHER: '其他',
            },
          },
          DATE_OF_BIRTH: '出生日期',
          DATE_OF_BIRTH_REQUIRED: '请选择您的出生日期',
          UPDATE: '更新',
          CHANGE_PASSWORD: '更改密码',
          OLD_PASSWORD: {
            LABEL: '旧密码',
            INPUT_PLACEHOLDER: '输入旧密码',
          },
          NEW_PASSWORD: {
            LABEL: '新密码',
            INPUT_PLACEHOLDER: '输入新密码',
          },
          CONFIRM_NEW_PASSWORD: {
            LABEL: '确认新密码',
            INPUT_PLACEHOLDER: '再次输入新密码',
          },
        },
        INPUT_PLACEHOLDER: {
          USER_NAME_INPUT_PLACEHOLDER: '请输入姓名',
          CUSTOMER_CODE_INPUT_PLACEHOLDER: '请输入客户代码',
          PHONE_INPUT_PLACEHOLDER: '请输入您的电话号码',
          EMAIL_INPUT_PLACEHOLDER: '请输入您的电子邮箱',
          OLD_PASSWORD_INPUT_PLACEHOLDER: '输入旧密码',
          NEW_PASSWORD_INPUT_PLACEHOLDER: '输入新密码',
          CONFIRM_NEW_PASSWORD_INPUT_PLACEHOLDER: '再次输入新密码',
        },
        ERRORS: {
          ERROR_USER_NAME_REQUIRED: '请输入您的姓名。',
          ERROR_PHONE_REQUIRED: '请输入您的电话号码。',
          ERROR_EMAIL_FORMAT: '电子邮箱格式不正确。',
          ERROR_EMAIL_REQUIRED: '请输入您的电子邮箱。',
          EMAIL_INVALID: '电子邮箱无效。',
          ERROR_GENDER_REQUIRED: '请选择您的性别。',
          DATE_OF_BIRTH_REQUIRED: '请选择您的出生日期。',
          ERROR_DATE_OF_BIRTH_REQUIRED: '请选择您的出生日期。',
          ERROR_OLD_PASSWORD: '请输入当前密码。',
          ERROR_NEW_PASSWORD: '请输入新密码。',
          ERROR_CONFIRM_NEW_PASSWORD: '请再次输入新密码。',
          ERROR_PASSWORD_MATCH: '两次输入的密码不一致。',
        },
      },
      MY_DEBT: {
        TITLE: '债务跟踪',
        DEBT_DAYS: '债务期限:',
        DATE_FILTER: '选择时间类型',
        DATE_ALL: '全部',
        DATE_TODAY: '今天',
        DATE_LAST_7_DAYS: '近7天',
        DATE_LAST_30_DAYS: '近30天',
        DATE_THIS_WEEK: '本周',
        DATE_THIS_MONTH: '本月',
        DATE_THIS_QUARTER: '本季度',
        DATE_THIS_YEAR: '今年',
        DATE_CUSTOM: '自定义',
        FROM_DATE: '从日期',
        TO_DATE: '至日期',
        SEARCH: '搜索',
        SEARCH_PLACEHOLDER: '搜索客户名称，订单编号...',
        ORDER_CODE: '订单编号',
        CREATED_DATE: '创建日期',
        TOTAL_AMOUNT: '总金额',
        PAID_AMOUNT: '已付金额',
        REMAINING_AMOUNT: '剩余',
        HISTORY: '历史',
        ACTIONS: '操作',
        VIEW: '查看',
        PAYMENT_HISTORY_FOR_ORDER: '订单的付款历史',
        PERIOD: '期',
        DATE: '日期',
        METHOD: '方法',
        BANK: '银行',
        AMOUNT: '金额',
        NOTE: '备注',
        NO_PAYMENT: '尚无付款。',
        LOADING: '加载中...',
        NO_DEBT_ORDER: '没有未付订单。',
        LOADING_DATA: '加载数据...',
        DAYS: '天',
		BUTTON_DETAIL: '查看订单详情',
		BUTTON_CLOSE:'关闭',
        VIEW_DEBT_CONFIG: '专属期限',
        DEBT_CONFIG_TITLE: '订单专属债务期限',
        DUE_DATE: '到期日',
        REASON: '原因',
        NO_CUSTOM_DEBT_CONFIG: '该订单正在使用系统默认债务期限。',
        LOADING_DEBT_CONFIG: '正在加载债务配置...',
        LOAD_DEBT_CONFIG_ERROR: '无法加载债务配置，请稍后重试。'
      },
      COMPANY_INFO: {
        TITLE: '公司信息',
        DETAIL: {
          COMPANY_NAME: '公司名称',
          REPRESENTATIVE: '法定代表人',
          TAX_CODE: '税号',
          ADDRESS: '地址',
          ATTACHED_DOCUMENTS: '附件文件',
          UPDATE: '更新',
        },
        INPUT_PLACEHOLDER: {
          COMPANY_NAME_INPUT_PLACEHOLDER: '请输入公司名称',
          REPRESENTATIVE_INPUT_PLACEHOLDER: '请输入法定代表人姓名',
          TAX_CODE_INPUT_PLACEHOLDER: '请输入税号',
          ADDRESS_INPUT_PLACEHOLDER: '请输入公司地址',
          ATTACHED_DOCUMENTS_INPUT_PLACEHOLDER: '上传附件文件（如有）',
        },
        ERRORS: {
          ERROR_COMPANY_NAME_REQUIRED: '请输入公司名称。',
          ERROR_REPRESENTATIVE_REQUIRED: '请输入法定代表人姓名。',
          ERROR_TAX_CODE_REQUIRED: '请输入税号。',
          ERROR_TAX_CODE_INVALID: '税号无效。',
          ERROR_ADDRESS_REQUIRED: '请输入地址。',
          ERROR_ATTACHED_DOCUMENTS_REQUIRED: '请上传附件文件。',
        },
        MESSAGES: {
          UPDATE_SUCCESS: '公司信息更新成功。',
          UPDATE_ERROR: '处理文件时出错。 请再试一次。',
        },
      },

      ORDER_INFO: {
        TITLE: '我的订单',
        TABLE: {
          ORDER_CODE: '订单编号',
          PURCHASE_DATE: '购买日期',
          PRODUCT: '商品',
          TOTAL: '总金额',
          STATUS: '状态',
          INVOICE: '发票',
        },
        DOWNLOAD: {
          PDF: '下载PDF',
          EXCEL: '下载Excel',
          RECEIPT: '下载交接记录',
          QUOTATION: '下载报价单',
          CONTRACT_WORD: '下载合同'
        },
        PAGINATION: {
          ITEMS_PER_PAGE: '每页数量',
          OF: '共',
        },
        INPUT_PLACEHOLDER: {
          SEARCH_PLACEHOLDER: '输入搜索内容',
          STATUS_PLACEHOLDER: '下单成功、订单确认等...',
          DATE_PLACEHOLDER: '选择搜索日期',
        },
        EMPTY: '暂无订单。',
      },

      ADDRESS_BOOK: {
        TITLE: '地址簿',
        DETAIL: {
          FULLNAME: '姓名',
          PHONE: '手机号码',
          PROVINCE: '省/城市',
          DISTRICT: '区/县',
          WARD: '乡/镇/街道',
          ADDRESS_NUMBER: '门牌号',
          ADDRESS: '详细地址',
          ADDRESS_TYPE: '地址类型',
          DEFAULT_ADDRESS: '设为默认地址',
          PRIVATE_OR_APARTMENT: '住宅 / 公寓',
          COMPANY_OR_OFFICE: '公司 / 办公室',
          ADD_NEW: '新增地址',
		  ADD_NEW_ADMINISTRATIVE: '新行政地址',
          ADDRESS_NOTE: '旧行政地址',
          ADDRESS_MAX_LENGTH: '最多100个字符',
          EDIT_ADDRESS: '编辑地址',
          DELETE: '删除',
          SAVE: '保存',
          CANCEL: '取消',
          UPDATE: '更新',
        },
        INPUT_PLACEHOLDER: {
          FULLNAME: '请输入姓名',
          PHONE: '请输入手机号码',
          PROVINCE: '请选择省/城市',
          DISTRICT: '请输入区/县',
          WARD: '请输入乡/镇/街道',
          ADDRESS_NUMBER: '请输入门牌号 / 详细地址',
          ADDRESS: '例如：12/3 白藤路',
        },
      },
    },
    BRANDS: {
      TITLE: '各种品牌的原厂零件和OEM零件',
    },
    VIDEO: {
      TITLE: '搜索相关零件',
      SUB_TITLE: '最准确 - 最便宜 - 离你最近',
    },
    FOOTER: {
      COMPANY_INFO: {
        TITLE: 'BIM BIM股份有限公司',
        NAME_EN: '国际名称',
        NAME_SHORT: '简称',
        TAX_CODE: '税号',
        ADDRESS: '地址：第119号B路，协平政区协平东政区，持德市，胡志明市，越南',
        HOTLINE: '热线',
        EMAIL: '电子邮箱',
        INTERNATIONAL: '国际名称',
        ABBREVIATED_NAME: '简称',
      },
      CONTACT: '联系',
      PRODUCT_SERVICE: {
        TITLE: '产品与服务',
        SPARE_PARTS: '按资料查找配件',
        MAINTENANCE: '叉车保养服务',
        USED_PARTS: '二手配件',
        REPAIR_TITLE: '维修与修复',
        TECHNICIAN: '叉车维修技师',
        BATTERY: '叉车电池修复',
        PUMP: '液压泵修复',
        INJECTION: '燃油喷射器修复',
      },
      DOWNLOAD: {
        TITLE: '下载',
        CATALOGUE: '目录',
        BROCHURE: '宣传册',
        MAINT_DOC: '保养文件',
        VIDEO: '视频',
      },
      LANGUAGE: {
        TITLE: '语言选项',
        VI: '越南语',
        EN: '英语',
        ZH: '中文',
      },
      PARTNERSHIP: {
        TITLE: '合作与链接',
        SUPPLIERS: '供应商',
        SELL_WITH_US: '与BimBim合作销售',
        CERTIFIED_BY: '经认证',
        CERTIFICATION_LOGO: '认证标志',
      },
      INFORMATION: {
        TITLE: '信息',
      },
    },
    FOOTER_BOTTOM: {
      FREE_APP: '免费下载应用：',
      CONNECT_WITH_US: '与我们联系',
      COPYRIGHT: '2025 © 版权所有 BIM BIM股份有限公司',
      COMPANY_COPYRIGHT_SUFFIX: '版权所有 BIM BIM股份有限公司',
      LICENSE: '营业执照编号0318955259，由胡志明市计划与投资局于2025年05月16日颁发',
      PRIVACY_POLICY: '隐私政策',
      TERMS_CONDITIONS: '条款与条件',
      APP_STORE: '在App Store下载',
      GOOGLE_PLAY: '在Google Play下载',
      LANGUAGE_DISCLAIMER:
        '对于英文版本与其他语言版本之间的任何差异，Bim Bim 概不负责。如有任何冲突，以英文版本为准。使用我们的网站即表示您已确认并同意我们的条款和条件.',
    },
    SIDE_WIDGETS: {
      CONTACT_US: '联系我们',
      CHAT_NOW: '立即咨询',
      CONSULTATION: '咨询',
    },
    ASK_FORM: {
      TITLE: '您需要更多咨询吗？',
      SALES_TEXT: '我们的销售专员将立即回复您的邮件',
      QUESTION_PLACEHOLDER: '*问题：',
      ADD_FILE: '添加图片、文件...',
      NAME_PLACEHOLDER: '*您的姓名：',
      EMAIL_PLACEHOLDER: '*您的邮箱：',
      PHONE_PLACEHOLDER: '*您的电话：',
      SEND_BTN: '发送问题',
      NOTIFICATIONS: {
        WARNING_TITLE: '通知',
        REQUIRED_QUESTION: '请输入您的问题',
        SUCCESS_TITLE: '成功',
        SUCCESS_MSG: '问题发送成功！',
        ERROR_TITLE: '错误',
        ERROR_MSG: '发生错误',
        SYSTEM_ERROR: '系统错误，请稍后再试。',
      },
    },
  },
};
